module.exports = __webpack_public_path__ + "img/document.461a2ba6.svg";